import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { allot_asse_loading : true, allot_asse: '', allot_asse_error: false};

export function allotAssess(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_All_ASSESSMENT:
        return {
            allot_asse_loading: true,
            allot_asse: '',
            allot_asse_error: false
        };
      case organisationConstants.RESPONSE_All_ASSESSMENT:
        return {
            allot_asse_loading: false,
            allot_asse: action.allot_asse,
            allot_asse_error: false
        };
      case organisationConstants.ERROR_All_ASSESSMENT:
        return { 
            allot_asse_loading: false,
            allot_asse: '',
            allot_asse_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/allotassesment.reducer.js